import { getComparisonMetadata } from './comparisonRisk';

export const isDirectGlobalCard = (comment = {}) => {
    const metadata = getComparisonMetadata(comment) || {};
    return [comment.source_review_method, metadata.source_review_method,
        metadata.fast_global_card_v1?.source_review_method].includes('direct_original_contract');
};

export const getGlobalCardPriority = (comment = {}) => {
    const metadata = getComparisonMetadata(comment) || {};
    const snapshot = metadata.fast_global_card_v1 || {};
    const rank = metadata.priority_rank ?? snapshot.priority_rank ?? comment.priority_rank;
    const reason = metadata.priority_reason ?? snapshot.priority_reason ?? comment.priority_reason;
    const status = metadata.priority_status ?? snapshot.priority_status ?? comment.priority_status;
    return {
        rank: Number.isInteger(rank) && rank > 0 ? rank : null,
        reason: typeof reason === 'string' ? reason.trim() : '',
        status,
    };
};

// A partially received or malformed order must never look like a final ranking.
// Ranks need not be contiguous here: a criterion filter can show only a subset.
export const getGlobalPriorityState = (comments = []) => {
    const cards = comments.filter(isDirectGlobalCard);
    if (!cards.length) return null;
    const priorities = cards.map(getGlobalCardPriority);
    if (priorities.every(({ status, rank, reason }) => status === 'final' && rank && reason)
        && new Set(priorities.map(({ rank }) => rank)).size === priorities.length) return 'final';
    return priorities.some(({ status }) => status === 'provisional') ? 'provisional' : 'unavailable';
};

export const globalCardNeedsConfirmation = (comment = {}) => {
    const metadata = getComparisonMetadata(comment) || {};
    const annotations = metadata.review_annotations || metadata.fast_global_card_v1?.review_annotations
        || comment.review_annotations || [];
    const uncertainties = metadata.fast_global_card_v1?.uncertainties || comment.uncertainties || [];
    return (Array.isArray(uncertainties) && uncertainties.some((value) => typeof value === 'string' && value.trim()))
        || (Array.isArray(annotations) && annotations.some((value) => (
        ['to_confirm', 'party_ambiguous', 'source_partial'].includes(value)
    )));
};
